import emailPayload from "../../../../../labs/email_payload.json";
import emailKBStructure from "../../../../../labs/EmailKBFromSignalR.json";
import { showToastMiddle } from "../../utils/showToast";
import { getSessionToken } from "../../services/bootstrap";
//import {fetchWithRetry}  from "../Helpers/fetchretry"

export default {
  state() {
    return {
      // emails: [],
      searchResults: null,
      isSearchLoading: false,
      tagsFilter: "",
      searchText: "", // Add search text state
      extractedTags: [],
      aiThemeTags: [],
      intelligentEmailAddress: '',
      emailKnowledgeBase: [],
      JWT: '',
      temporaryToken: '',
      nodeIdSelected: '0',
      currentPageSelected: 1,
      totalPages: 1,
      heirarchyMode: 'RAW', //OPTIONS: RAW = 0, BY_TOPIC, BY_SENDER, BY_SENDER_GROUP
      aiTags: null,
      filterToConceptKeyMap: {
        Contact: 1,
        FacebookUser: 2,
        LinkedInUser: 3,
        Venture: 4,
        Stratagem: 5,
        Agent: 6,
        Group: 7,
        Project: 8,
        Job: 9,
        CustomContent: 10,
        Documents: 11,
        EmailData: 12,
        Wizard: 13,
        Portfolio: 14,
        OnlinePresence: 15,
        Currency: 16,
        CalendarEvent: 17,
        Website: 18,
        Image: 19,
        DataSet: 20,
        Query: 21,
        EmailKnowledgeBase: 22,
        Classification: 23,
        TaskList: 24,
        Audio:25,
        Video:26
      }
    };
  },
  mutations: {
    setSearchLoading(state, isLoading) {
      state.isSearchLoading = isLoading;
    },
    aiTags(state, tags) {
      state.aiTags = tags;
    },
    searchResults(state, results) {
      state.searchResults = results;
    },
    clearSearchResults(state) {
      state.searchResults = null;
      state.isSearchLoading = false;
    },
    triggerEmailKBWatcher(state) {
      // a hack to force the computed property that holds the treeview data to trigger
      if (state.emailKnowledgeBase.length === 0) return
      state.emailKnowledgeBase[0] = { ...state.emailKnowledgeBase[0], _trigger: Math.random() };
    },
    temporaryToken(state, token) {
      state.temporaryToken = token;
    },
    JWT(state, jwt) {
      state.JWT = jwt;

    },
    intelligentEmailAddress(state, address) {
      state.intelligentEmailAddress = address
    },
    addToEmailKnowledgeBase(state, obj) {
      if (!state.emailKnowledgeBase.find((el) => el.id === obj.id)) {
        state.emailKnowledgeBase.push(obj);
      }

      // If in search mode, also add to search results if it doesn't exist
      if (state.searchResults !== null && !state.searchResults.find((el) => el.id === obj.id)) {
        state.searchResults.push(obj);
      }
    },
    setEmailKnowledgeBase(state, object) {
      state.emailKnowledgeBase = object;
      //alert(`KB = ${state.emailKnowledgeBase}`);
    },
    addEmail(state, email) {
      state.emails.push(email);
    },
    tagsFilter(state, filter) {
      state.tagsFilter = filter;
    },
    wipeExtractedTags(state) {
      state.extractedTags = [];
    },
    wipeAiThemeTags(state) {
      state.aiThemeTags = [];
    },
    setSearchText(state, searchText) {
      state.searchText = searchText;
    },
    heirarchyMode(state, mode) {
      state.heirarchyMode = mode;
    },
    nodeIdSelected(state, mode) {
      state.nodeIdSelected = mode;
    },
    currentPageSelected(state, page){
      state.currentPageSelected = page;
    },
    totalPages(state, pages){
      state.totalPages = pages;
    },
    setExtractedTags(state, tags) {
      state.extractedTags = tags;
    },
    setAiThemeTags(state, tags) {
      state.aiThemeTags = tags;
    }
  },
  getters: {
    isSearchLoading(state) {
      return state.isSearchLoading;
    },
    aiTags(state) {
      return state.aiTags;
    },
    intelligentEmailAddress(state) {
      return state.intelligentEmailAddress
    },
    emails(state) {
      return state.emails;
    },
    tagsFilter(state) {
      return state.tagsFilter;
    },
    searchText(state) {
      return state.searchText;
    },
    extractedTags(state) {
      const order = ["User", "Project", "Venture", "CalendarEvent", "Documents", "DataSet", "Image", "Video", "Audio", "Website"];
      const rearrangedArray = state.extractedTags.sort((a, b) => {
        const indexA = order.indexOf(a.tag);
        const indexB = order.indexOf(b.tag);

        // If the tag is in the order array, use its index; otherwise, move it to the end
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
      return rearrangedArray;
    },
    aiThemeTags(state){
      return state.aiThemeTags;
    },
    emailKnowledgeBase(state) {
      if (state.searchResults === null) {
        return { KB: state.emailKnowledgeBase };
      }
      return { KB: state.searchResults, search: true };
    },
    JWT(state) {
      return state.JWT;
    },
    temporaryToken(state) {
      return state.temporaryToken;
    },
    heirarchyMode(state) {
      return state.heirarchyMode;
    },
    nodeIdSelected(state) {
      return state.nodeIdSelected;
    },
    currentPageSelected(state){
      return state.currentPageSelected;
    },
    totalPages(state){
      return state.totalPages; 
    },
    filterToConceptKeyMap(state) {
      return state.filterToConceptKeyMap;
    }
  },
  actions: {
    async regenAITags(context, searchTerm) {
      try {
        const response = await fetch(`${context.getters.VUE_APP_APIURL}/RegenAITags`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const tags = await response.json();
        console.log("🚀 ~ regenAITags ~ tags:", tags)

        context.commit('aiTags', tags);
      } catch (error) {
        console.error("Error fetching ai tags:", error);
        return null; // Return null or handle the error appropriately
      }
    },
    async fetchSearchResults(context, searchTerm) {
      try {
        console.log("Searching for:", searchTerm);
        context.commit('setSearchLoading', true);
        context.commit("setEmailKnowledgeBase", []);
        const token = getSessionToken();

        if (!token) {
          console.error("No session token available. Bootstrap not completed.");
          return;
        }

        let categoryId = 4; //AI Tag

        const response = await fetch(
          `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseSearch/${categoryId}/${encodeURIComponent(searchTerm)}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-Session-Token": token
            },
          });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // ---------------- DIAGNOSTIC LOGGING ----------------
        console.group("🔍 EmailKnowledgeBaseSearch Payload Audit");
        console.log("Raw items count:", data.items?.length);
        if (data.items && data.items.length > 0) {
          const sample = data.items[0];
          console.log("Sample Item Structure:", sample);
          console.log("Sample ID type:", typeof sample.id, "| Value:", sample.id);
          console.log("Sample ParentID type:", typeof sample.parentId, "| Value:", sample.parentId);
          
          // Check for duplicates
          const ids = data.items.map(i => i.id);
          const duplicates = ids.filter((id, index) => ids.indexOf(id) !== index);
          console.log("Duplicate IDs count:", duplicates.length);
          if (duplicates.length > 0) {
            console.warn("First 5 duplicate IDs found:", duplicates.slice(0, 5));
          }
        }
        console.groupEnd();
        // ----------------------------------------------------

        //console.log("Search Results:", data); // Log or handle the data as needed
        if (data.partialResults) showToastMiddle('Partial results returned, please refine your search.');
        //alert(data.items);
        context.commit('searchResults', data.items);
      } catch (error) {
        console.error("Error fetching search results:", error);
        return null; // Return null or handle the error appropriately
      } finally {
        context.commit('setSearchLoading', false);
      }
    },
    async fetchAIQueryResults(context, query) {
      try {
        console.log("AI query for:", query);
        context.commit('setSearchLoading', true);
        const token = getSessionToken();

        if (!token) {
          console.error("No session token available. Bootstrap not completed.");
          return;
        }

        let categoryId = 4; //AI Tag

        const response = await fetch(
          `${context.getters.VUE_APP_APIURL}/EmailAnalysisQuery/${categoryId}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-Session-Token": token
            },
            body: JSON.stringify(query)
          });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        //console.log("Search Results:", data); // Log or handle the data as needed
        if (data.partialResults) showToastMiddle('Partial results returned, please refine your search.');

        context.commit('searchResults', data.items);
      } catch (error) {
        console.error("Error fetching AI query results:", error);
        return null; // Return null or handle the error appropriately
      } finally {
        context.commit('setSearchLoading', false);
      }
    },
    async ProcessMailbox(context, provider) {
      const token = getSessionToken();

      if (!token) {
        console.error("No session token available. Bootstrap not completed.");
        return;
      }

      let res = await fetch(`${context.getters.VUE_APP_APIURL}/ProcessMailbox`, {
        method: 'POST',
        headers: {
          'accept': 'text/plain',
          'Content-Type': 'application/json',
          "X-Session-Token": token
        },
        body: JSON.stringify({
          emailAddress: "",
          emailProvider: provider,
          top: 1000
        })
      });

      if (!res.ok) {
        // showToastMiddle('Error processing mailbox.');
        return;
      } else {
        // showToastMiddle('Mailbox processing...');
      }

    },
    extractTagsFromEmails(context, emails) {
      // let totalTags = [];
      emails
        .map((email) => {
          console.log("🚀 ~ .map ~ email:", email)
          //  if (!email.ModelTags) return
          return email.modelTags?.tagsList;
        })
        .forEach((arr) =>
          arr.forEach((tag) => {
            let correctTag = context.getters.extractedTags.find((el) => el.tag === tag.type);
            if (correctTag) {
              if (!correctTag.rootType) {
                correctTag.count++;
              }
              else {
                let matchingUniqueTag = context.getters.extractedTags.find(
                  (el) => el.tag.toLowerCase() === tag.type.toLowerCase() &&
                    el.descs.find((d) => d.toLowerCase() === tag.desc.toLowerCase()));
                if (!matchingUniqueTag) {
                  correctTag.count++;
                  correctTag.descs.push(tag.desc);
                  //console.log("UNIQUE TAG:", tag.desc)
                }
              }
            } else {
              //alert('adding tag type:' + tag.type + ' custom=' + tag.custom);
              context.getters.extractedTags.push({ tag: tag.type, desc: tag.desc, descs: [tag.desc], custom: tag.custom, rootType: tag.rootType, count: 1 });
            }
          })
        );
      //  totalTags.forEach(tag => {
      //   context.getters.extractedTags.push(tag)
      //  });
    },
    async processAiThemeTags({ commit }, tags) {
      // Guard against undefined payload or missing tagsList
      const list = tags?.tagsList || (Array.isArray(tags) ? tags : null);

      if (!list || !Array.isArray(list)) {
        console.warn("processAiThemeTags received invalid or empty tags data:", tags);
        commit("setAiThemeTags", []);
        return;
      }

      const map = new Map();

      for (let i = 0; i < list.length; i++) {
        const tag = list[i];
        if (!tag) continue;

        let entry = map.get(tag.type);
        if (!entry) {
          entry = {
            tag: tag.type,
            desc: tag.desc,
            descs: [tag.desc],
            custom: tag.custom,
            rootType: tag.rootType,
            count: 1
          };
          map.set(tag.type, entry);
        } else {
          if (!entry.rootType) {
            entry.count++;
          } else {
            if (!entry.descs.includes(tag.desc)) {
              entry.count++;
              entry.descs.push(tag.desc);
            }
          }
        }

        // Yield occasionally to keep UI responsive
        if (i % 500 === 0) {
          await new Promise(requestAnimationFrame);
        }
      }

      // Single reactive update
      commit("setAiThemeTags", Array.from(map.values()));
    },
    async processTags({ commit }, tags) {
        const map = new Map();
        const list = tags.tagsList;

        for (let i = 0; i < list.length; i++) {
          const tag = list[i];

          let entry = map.get(tag.type);
          if (!entry) {
            entry = {
              tag: tag.type,
              desc: tag.desc,
              descs: [tag.desc],
              custom: tag.custom,
              rootType: tag.rootType,
              count: 1
            };
            map.set(tag.type, entry);
          } else {
            if (!entry.rootType) {
              entry.count++;
            } else {
              if (!entry.descs.includes(tag.desc)) {
                entry.count++;
                entry.descs.push(tag.desc);
              }
            }
          }

          // yield occasionally to keep UI responsive
          if (i % 500 === 0) {
            await new Promise(requestAnimationFrame);
          }
        }

        // ✅ single reactive update
        commit("setExtractedTags", Array.from(map.values()));
      },
    processEmails(context, emails) {

      emails.forEach(email => {
        try {
          context.commit("addEmail", email);
          console.log('email added', email.subject)
        }
        catch (e) {
          console.log('error adding email ', e)
        }
      });
    },
    async emailSync(context) {

      let res = await fetch(
        `${context.getters.VUE_APP_APIURL}/Email/Sync`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ApiKey: context.getters.apiKey
          },
          method: "POST",
        }
      );

      const tempToken = await res.json();
      // const tempToken = await res.json();
      context.commit('temporaryToken', tempToken.access_token)


    },
    async getIntelligentEmailAddress(context) {

      let res = await fetch(`${context.getters.VUE_APP_APIURL}/Email/IEA`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ApiKey: context.getters.apiKey
        },
        method: "GET"
      })
      console.log("🚀 ~ getIntelligentEmailAddress ~ res:", res)

      let address = await res.json();
      context.dispatch('checkIfTokenHasExpired', res);
      context.commit('intelligentEmailAddress', address.IEA);
    },
    async checkIfEmailAddressIsFree(context, email) {

      let res = await fetch(`${context.getters.VUE_APP_APIURL}/Email/IEA/Check`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ApiKey: context.getters.apiKey
        },
        body: JSON.stringify({
          "IEA": email + '@venturestar.email',
          "Temp": false
        }),
        method: "POST"
      })
      console.log("🚀 ~ checkIfEmailAddressIsFree ~ res:", res)

      let isFree = await res.json();
      console.log("🚀 ~ checkIfEmailAddressIsFree ~ address:",)
      return isFree;

    },
    async putIntelligentEmailAddress(context, email) {

      let res = await fetch(`${context.getters.VUE_APP_APIURL}/Email/IEA`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ApiKey: context.getters.apiKey
        },
        body: JSON.stringify({
          "IEA": email,
          "Temp": false
        }),
      })
      console.log("🚀 ~ putIntelligentEmailAddress ~ res:", res)

      let address = await res.json();
      console.log("🚀 ~ putIntelligentEmailAddress ~ address:", address)

    },
    async confirmEmailAddress(context) {
      let res = await fetch(`${context.getters.VUE_APP_APIURL}/Email/Confirm/${context.getters.temporaryToken}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ApiKey: context.getters.apiKey
        },
        method: "POST"
      })

      let JWTToken = await res.json();

      context.commit('JWT', JWTToken);
      return JWTToken;
    },
    addEmail(context, email) {
      //alert('hit');
      context.commit("addEmail", email);
      context.commit("extractTagsFromEmails", context.state.emails);
      return true;
    },
    async emailKnowledgeBase(context) {
      let heirarchyMode = context.getters.heirarchyMode;
      let url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBase`
      switch (heirarchyMode) {
        case "BY_TOPIC":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/1`;
          break;
        case "BY_SENDER":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/2`;
          break;
      }
      let res = await fetch(
        url,
        {
          headers: {
            method: "GET",
          },
        }
      );

      const treeViewData = await res.json();
      //alert(`${JSON.stringify(treeViewData)}`);
      alert(treeViewData.pages);
      context.commit("totalPages", treeViewData.pages);
      context.commit("setEmailKnowledgeBase", treeViewData.items);
    },
    async emailKnowledgeBaseNode(context) {
      let heirarchyMode = context.getters.heirarchyMode;
      let nodeIdSelected = context.getters.nodeIdSelected;
      let pageSelected = String(context.getters.currentPageSelected - 1);
      let url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/0/${nodeIdSelected}/${pageSelected}`;
      switch (heirarchyMode) {
        case "BY_TOPIC":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/1/${nodeIdSelected}/${pageSelected}`;
          break;
        case "BY_SENDER":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/2/${nodeIdSelected}/${pageSelected}`;
          break;
        case "BY_MAILBOX":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/5/${nodeIdSelected}/${pageSelected}`;
          break;
        case "BY_TAG":
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/4/${nodeIdSelected}/${pageSelected}`;
          break;
        default:
          url = `${context.getters.VUE_APP_APIURL}/EmailKnowledgeBaseView/0/${nodeIdSelected}/${pageSelected}`;
          break;
      }

      const token = getSessionToken();

      if (!token) {
        console.error("No session token available. Bootstrap not completed.");
        return;
      }

      
        let res = await fetch(
          url,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-Session-Token": token
            },
          }
        );
      
        const treeViewData = await res.json();
        
        const filteredItems = treeViewData.items.filter(
          item => item.concept !== 24 // task list
        );

        filteredItems.forEach((item) => {
          context.commit("addToEmailKnowledgeBase", item);
        });

        context.commit('triggerEmailKBWatcher');
        context.commit("totalPages", treeViewData.pages);
        return treeViewData;
      
     

    },
    async aiThemeTags(context) {

      const token = getSessionToken();

      if (!token) {
        console.error("No session token available. Bootstrap not completed.");
        return;
      }

      const res = await fetch(
        `${context.getters.VUE_APP_APIURL}/AIThemeModelTags`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Session-Token": token
          }
        }
      );

      if (res.status === 401) {
        console.error("Unauthorized - invalid session token");
        return;
      }

      if (res.status === 403) {
        console.error("Forbidden - origin mismatch?");
        return;
      }

      if (res.status === 204) return;

      const modelTags = await res.json();
      console.log("🚀 ~ AIThemeModelTags:", modelTags);

      context.commit("wipeAiThemeTags");
      context.dispatch("processAiThemeTags", modelTags);
    },
    async aiThemeTagsGenerate(context) {
      const token = getSessionToken();

      if (!token) {
        console.error("No session token available. Bootstrap not completed.");
        return;
      }

      const res = await fetch(
        `${context.getters.VUE_APP_APIURL}/GenerateAIThemeModelTags`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Session-Token": token
          }
        }
      );

      if (res.status === 401) {
        console.error("Unauthorized - invalid session token");
        return;
      }

      if (res.status === 403) {
        console.error("Forbidden - origin mismatch?");
        return;
      }

      if (res.status === 204 || !res.ok) return;

      const modelTags = await res.json();
      console.log("🚀 ~ AIThemeModelTags:", modelTags);

      // Check if response contains valid tags before proceeding
      if (!modelTags) {
        console.warn("GenerateAIThemeModelTags returned empty body.");
        return;
      }

      context.commit("wipeAiThemeTags");
      context.dispatch("processAiThemeTags", modelTags);
    },
    async emailModelTags(context) {

      const token = getSessionToken();

      if (!token) {
        console.error("No session token available. Bootstrap not completed.");
        return;
      }

      const res = await fetch(
        `${context.getters.VUE_APP_APIURL}/ModelTags`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Session-Token": token
          }
        }
      );

      if (res.status === 401) {
        console.error("Unauthorized - invalid session token");
        return;
      }

      if (res.status === 403) {
        console.error("Forbidden - origin mismatch?");
        return;
      }

      if (res.status === 204) return;

      const modelTags = await res.json();
      console.log("🚀 ~ modelTags:", modelTags);

      if (context.getters.extractedTags.length === modelTags.tagsList.length) return;

      context.commit("wipeExtractedTags");
      context.dispatch("processTags", modelTags);
    },

    async emailsRaw(context) {
      let res = await fetch(
        `${context.getters.VUE_APP_APIURL}/ModelEmails`,
        {
          headers: {
            method: "GET",
          },
        }
      );

      const emails = await res.json();

      context.dispatch("processEmails", emails);
    },
  },
  async significantTags(context) {
    let res = await fetch()
  }
};
